<tidy-row class="extra-bottom-padding">
  <tidy-text
    [header]="'What do you want to offer?'" />
</tidy-row>

@for (item of whatToOfferItems; track item) {
  <tidy-card class="card-checkbox" [ngClass]="{'selected-card-checkbox': item.isSelected}" (click)="selectWhatToOffer(item)">
    <div style="display: flex; align-items: center;">
      <tidy-text
        [body]="'<b>' + item?.name + '</b>'" />
    </div>
    <tidy-row>
      <tidy-text
        [body]="item?.description" />
    </tidy-row>
  </tidy-card>
}

<tidy-row class="extra-top-padding extra-bottom-padding">
  <tidy-text
    [header]="'How do you want guests to request upsells?'" />
</tidy-row>

<tidy-row class="extra-bottom-padding">
  @for (item of howToRequestItems; track item) {
    <tidy-card class="card-checkbox" [ngClass]="{'selected-card-checkbox': item.isSelected}" (click)="selectWhatToOffer(item)">
      <div style="display: flex; align-items: center;">
        <tidy-text
          [body]="item?.name" />
      </div>
    </tidy-card>
  }
</tidy-row>

<tidy-button
  [text]="'Save Upsell Settings'"
  [action]="boundSave"
  class="primary" />


